import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface DashboardStats {
  applications: number
  notifications_today: number
  notifications_total: number
  active_live_sessions: number
  delivery_rate: number
  failed_deliveries: number
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboardStats'],
    queryFn: () => api.get<DashboardStats>('/dashboard/stats'),
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}
